import "./noLenderModal.css";
import React, { useEffect, useState } from "react";
import { Button } from "react-bootstrap";
import { Modal } from "antd";
import { checkAccess } from "../../../../../Auth";
import { UR_Owner } from "./../../../../../State.js";
import StyledModal from "./../../common/styledModal";
import Lenders from "../../../../../Management/Lenders";


const NoLenderModal = ({ isOpen, onClose, addLenders }) => {
  const [isOpen_no_lender, setIsOpen_no_lender] = useState(false);
  const [addLenderModal, setAddLenderModal] = useState(false);

  useEffect(() => {
    setIsOpen_no_lender(isOpen);
    // console.log("isOpen", isOpen, isOpen_no_lender);
    // console.log('role: ', checkAccess([UR_Owner]));
  }, [isOpen]);

  const handleClose = () => {
    // console.log("handleClose", isOpen_no_lender);
    onClose && onClose();
    setIsOpen_no_lender(false);
  };

  const openAddLenderModal = () => {
    setAddLenderModal(true);
  };

  const hasSavedLenders = (has) => {
    addLenders(has);
  }

  return (
    <>
    <StyledModal
      isOpen={isOpen_no_lender}
      onClose={handleClose}
      title="No lenders added"
      width="410px"
      footer={false}
    >
      <div className="modal-content">
        {!checkAccess([UR_Owner]) ? (
          <>
            <div className="modal-content-title">
              <span>No lender added</span>
            </div>
            <div className="modal-content-box" style={{ marginBottom: "50px" }}>
              <span>
                It looks like you haven't added a lender yet. Please contact
                your account administrator for assistance so you can explore
                rates and pricing.
              </span>
            </div>
          </>
        ) : (
          <>
            <div className="modal-content-title">
              <span>No lender added</span>
            </div>
            <div className="modal-content-box">
              <span>
                It looks like you haven’t added a lender yet. Please add at least one lender to start exploring rates and pricing.
              </span>
            </div>
            <div className="modal-footer">
              <div className="modal-footer-button modal-footer-button-primary cursor-pointer" onClick={() => handleClose()}>
                <span>Cancel</span>
              </div>
              <div
                className="modal-footer-button modal-footer-button-default cursor-pointer"
                onClick={openAddLenderModal}
              >
                <span>Add now</span>
              </div>
            </div>
          </>
        )}
      </div>
    </StyledModal>
    <Modal
        open={addLenderModal}
        onCancel={() => setAddLenderModal(false)}
        centered
        footer={[
          <Button key="back" onClick={() => setAddLenderModal(false)}>
            Cancel
          </Button>,
        ]}
        width={1200}
      >
        <Lenders statsigSource="rates" hasSavedLenders={(has) => {
          setAddLenderModal(false);
          hasSavedLenders(has);
        }}/>
      </Modal>
    </>
    
  );
};

export default NoLenderModal;
